import { createStore } from 'vuex'

export default createStore({
    state: {
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || null
    },
    getters: {
    },
    mutations: {
        setUser(state, data) {
            state.userInfo = data;
            localStorage.setItem("userInfo", JSON.stringify(data));
        },
        clearUser(state) {
            state.userInfo = null;
            localStorage.removeItem('userInfo');
        }
    },
    actions: {
    },
    modules: {
    }
})
